import { useEffect, useState } from "react";
import { AppHeader } from "./components/Header/AppHeader";
import { RiskMap } from "./components/Map/RiskMap";
import { CellDrawer } from "./components/Drawer/CellDrawer";
import { ColdStartOverlay } from "./components/shared/ColdStartOverlay";
import { syncFromUrl } from "./store/uiStore";
import { useUIStore } from "./store/uiStore";
import { useTicks } from "./hooks/useTicks";

function TickInitializer() {
  const { ticks } = useTicks();
  const { activeTick, setTick } = useUIStore();

  useEffect(() => {
    if (!activeTick && ticks.length > 0) {
      setTick(ticks[0]);
    }
  }, [ticks, activeTick, setTick]);

  return null;
}

function useColdStartOverlay(): boolean {
  const { ticks, isLoading } = useTicks();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isLoading || ticks.length > 0) {
      setShow(false);
      return;
    }
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, [isLoading, ticks.length]);

  return show && ticks.length === 0;
}

function AppShell() {
  const showColdStart = useColdStartOverlay();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100svh",
        overflow: "hidden",
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
      }}
    >
      <ColdStartOverlay visible={showColdStart} />
      <TickInitializer />
      <AppHeader />
      <div style={{ display: "flex", flex: 1, overflow: "hidden", minHeight: 0 }}>
        <RiskMap />
        <CellDrawer />
      </div>
    </div>
  );
}

export function App() {
  useEffect(() => {
    syncFromUrl();
  }, []);

  return <AppShell />;
}
